export default __webpack_public_path__ + "static/media/screen4.5ff7d2db.png";